class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    const activeMediaId = this.openedBy.getAttribute('data-media-id');

    this.querySelectorAll('.js-product-gallery-media[data-media-id]').forEach(
      (media) => {
        media.parentElement.classList.add('hidden');
        media.parentElement.parentElement.classList.add('hidden');
      },
    );

    const mediaParent = this.querySelector(
      `.js-product-gallery-media[data-media-id="${activeMediaId}"]`,
    ).parentElement;

    mediaParent.classList.remove('hidden');
    mediaParent.parentElement.classList.remove('hidden');
  }
}

customElements.define('product-modal', ProductModal);
